var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a_logout {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n\n            .b_logout {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a_logout",
    d: "M73,671.75A1.75,1.75,0,0,1,74.75,670h17.5A1.75,1.75,0,0,1,94,671.75v17.5a1.75,1.75,0,0,1-1.75,1.75H74.75a1.75,1.75,0,0,1-1.75-1.75v-3.5h1.75v2.625a.875.875,0,0,0,.875.875H91.374a.875.875,0,0,0,.875-.875V672.625a.875.875,0,0,0-.875-.875H75.625a.875.875,0,0,0-.875.875v2.625H73Zm15.525,8.1a.922.922,0,0,1,.077,1.215l-.077.087-4.6,4.6-1.3-1.3,3.073-3.074H73v-1.751H85.7l-3.073-3.074,1.3-1.3Z",
    transform: "translate(-67.5 -664.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b_logout",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_logout.5b1a5a95811b8f0e0dc53a0a150a9dbf.svg";